import { EuiBasicTable } from "@elastic/eui";
import React from "react";

import {
    useRolesQuery,
    useShopGroupsQuery,
    useUpdateUserMutation,
    useUsersQuery,
} from "../../api/react-query/queries/admin-page";
import InlineComboBoxEditor from "../../components/editors/InlineComboBoxEditor";
import ConfirmationDialog from "../../components/modals/ConfirmationDialog";
import { Role, ShopGroup, User } from "../../utils/types";
import RoleBadge from "./RoleBadge";

const PermissionsUsersList = () => {
    const { users } = useUsersQuery();
    const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
    const { shopGroups, shopGroupsLoading } = useShopGroupsQuery();
    const { roles, rolesLoading } = useRolesQuery();
    const { mutate: updateUser } = useUpdateUserMutation();

    const handleSaveShopGroups = (user: User, newData: string[]) =>
        updateUser({
            ...user,
            shop_groups: newData,
            roles: user.roles.map((role) => role.id),
        });

    const handleSaveUserRoles = (user: User, newData: string[]) =>
        updateUser({
            ...user,
            roles: newData,
            shop_groups: user.shop_groups.map((shopGroup) => shopGroup.id),
        });

    console.log("SGs", users);

    const columns = [
        {
            field: "first_name",
            name: "First Name",
            sortable: true,
            width: "150px",
        },
        {
            field: "last_name",
            name: "Last Name",
            sortable: true,
            width: "150px",
        },
        {
            field: "email",
            name: "Email",
            sortable: true,
            width: "275px",
        },
        {
            field: "shop_groups",
            name: "Shop Groups",
            sortable: true,
            render: (row: ShopGroup[], column: User) => {
                return (
                    <InlineComboBoxEditor
                        itemType="shop group"
                        isLoading={shopGroupsLoading}
                        options={shopGroups.map((shopGroup: ShopGroup) => ({
                            label: shopGroup.name,
                            value: shopGroup.id,
                        }))}
                        initialOptions={row.map((shopGroup) => ({ label: shopGroup.name, value: shopGroup.id }))}
                        onSave={(newShopGroups) => handleSaveShopGroups(column, newShopGroups)}
                    />
                );
            },
        },
        {
            field: "roles",
            name: "Roles",
            sortable: true,
            render: (row: ShopGroup[], column: User) => {
                return (
                    <InlineComboBoxEditor
                        itemType="role"
                        isLoading={rolesLoading}
                        options={roles.map((role: Role) => ({ label: role.name, value: role.id }))}
                        initialOptions={row.map((role) => ({ label: role.name, value: role.id }))}
                        onSave={(newRoles) => handleSaveUserRoles(column, newRoles)}
                        renderValue={(value) => <RoleBadge role={value ?? ""} />}
                    />
                );
            },
        },
    ];

    return (
        <>
            <EuiBasicTable items={users} columns={columns} itemId="id" />
            <ConfirmationDialog
                isOpen={confirmDialogOpen}
                cancel={() => setConfirmDialogOpen(false)}
                confirm={() => {
                    setConfirmDialogOpen(false);
                }}
                question={"Weet je zeker dat je deze wilt wissen?"}
            />
        </>
    );
};

export default PermissionsUsersList;
